export const eva = function (eva: number, property: string = 'backgroundColor') {
	let color: string = `var(--eva-level-${Math.min(5, Math.floor(eva/2)+1)})`

	let result = {}
	result[property] = color
	return result
}
